import React, { useRef } from "react";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import { useStep2Data } from "./hooks/useStep2Data";
import { sanitizeStepperPriceInput } from "./utils/helpers";

export const Step2 = ({
  stepperFormdata,
  handleChange,
  fieldErrors,
  setStepperFormdata,
  minimumPrice,
}) => {
  const {
    subcategory,
    setsubCategory,
    categories,
    filteredSubSubcategories,
    products,
    productsLoading,
    printingPoducts,
    filterSubSubCategories,
    getFilteredProducts,
    categorySelectValue,
    subcategorySelectValue,
    subsubcategorySelectValue,
  } = useStep2Data(stepperFormdata);

  const inputRef = useRef(null);

  const handleAddTag = (tagInput) => {
    if (!tagInput) return;

    const newTags = tagInput
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag.length > 0);

    setStepperFormdata((prevData) => {
      let updatedTags = [...prevData.tags];

      for (const tag of newTags) {
        if (tag.length > 20) {
          alert(`Tag "${tag}" exceeds 20 characters.`);
          continue;
        }

        if (updatedTags.length >= 10) {
          break;
        }

        if (
          !updatedTags.some((t) => t.name.toLowerCase() === tag.toLowerCase())
        ) {
          updatedTags.push({ name: tag });
        }
      }

      return { ...prevData, tags: updatedTags };
    });
  };

  const isAddTagDisabled = stepperFormdata.tags.length >= 10;

  const handleDeleteTag = (index) => {
    setStepperFormdata((prevData) => ({
      ...prevData,
      tags: prevData.tags.filter((_, i) => i !== index),
    }));
  };

  const handleButtonClick = () => {
    if (inputRef.current.value) {
      handleAddTag(inputRef.current.value);
      inputRef.current.value = "";
    }
  };

  const aiModelOptions = ["AI", "3D", "Real", "Mix"];

  return (
    <>
      <div className="">
        <h4 className="text-center fw-normal mb-3">About this mockup</h4>
        <div className="row mb-3">
          <div className="col-md-12 text-start">
            <div className="row">
              <div className="col-6 fs-6">
                <p className="fs-6">
                  Help users find your mockup. Add Keywords that Describe the
                  product, mood of the image, style or Setting.
                </p>
              </div>
              <div className="col-6">
                <div className="input-group mb-3">
                  <input
                    ref={inputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleAddTag(e.target.value);
                        e.target.value = "";
                      }
                    }}
                    maxLength={100}
                    type="text"
                    className="form-control py-2"
                    placeholder="Add up to 10 Keywords (max 20 chars)"
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                  />
                  <button
                    className="btn btn-dark"
                    type="button"
                    id="button-addon2"
                    onClick={handleButtonClick}
                    disabled={isAddTagDisabled}
                  >
                    <Add />
                  </button>
                </div>

                <ul className="d-flex fs-6 flex-wrap gap-3 align-items-center">
                  {stepperFormdata.tags.map((tag, index) => (
                    <li
                      key={index}
                      className="d-flex flex-wrap py-1 px-3 align-items-center position-relative rounded-5"
                      style={{
                        backgroundColor: "#C6CECE",
                        maxWidth: "160px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        fontSize: "0.5rem",
                        lineHeight: "1rem",
                        paddingRight: "24px",
                      }}
                    >
                      <p
                        className="m-0 overflow-hidden text-truncate"
                        style={{ fontSize: "small" }}
                        title={tag.name}
                      >
                        {tag.name}
                      </p>
                      <p
                        className="position-absolute m-0"
                        onClick={() => handleDeleteTag(index)}
                        style={{ right: -7, bottom: 5, cursor: "pointer" }}
                      >
                        <Close
                          sx={{
                            color: "white",
                            backgroundColor: "black",
                            borderRadius: "50%",
                            fontSize: "19px",
                          }}
                        />
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 fs-6">
                <p className="fs-6">
                  Users want to know if your mockup was made by AI, 3d software,
                  or if it's real photo. If it's some kind of mix Or other
                  technique - select the option{" "}
                  <a
                    href="/blog/mockup-types"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-underline"
                  >
                    Read our guidance
                  </a>
                </p>
              </div>
              <div className="col-md-6 fs-6">
                <label className="d-block" htmlFor="technique">
                  Select One
                </label>
                {aiModelOptions.map((option) => (
                  <div key={option} className="d-flex gap-3 align-items-center justify-content-start">
                    <input
                      onClick={() => handleChange("ai_models", option)}
                      checked={stepperFormdata?.ai_models === option}
                      type="radio"
                      id={option}
                      name="technique"
                      className="form-check-input mt-0"
                    />
                    <label htmlFor={option}>{option}</label>
                  </div>
                ))}
                <p className="text-danger text-start">
                  {fieldErrors?.ai_models}
                </p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 fs-6">
                <p className="fs-6">
                  Set Your Price. You can also give it for free if you're In the
                  mood.
                </p>
              </div>
              <div className="col-md-6">
                {!stepperFormdata?.is_free && (
                  <div className="">
                    <div className="form-group">
                      <input
                        type="text"
                        inputMode="decimal"
                        onChange={(e) => {
                          const next = sanitizeStepperPriceInput(
                            e.target.value,
                          );
                          if (next !== null) {
                            handleChange("price", next);
                          }
                        }}
                        value={stepperFormdata?.price ?? ""}
                        className="form-control rounded-4"
                        style={{ height: "48px", width: "168px" }}
                        placeholder="Price"
                        id="price"
                        autoComplete="off"
                      />
                    </div>
                    <p className="text-danger text-start fs-6">
                      {fieldErrors?.price}
                    </p>
                  </div>
                )}
                <div className="form-group d-flex justify-content-start gap-2">
                  <p className="m-0 fs-6">
                    minimal price is {minimumPrice}$ or you can give it free
                  </p>
                  <div className="d-flex gap-2 align-items-center justify-content-start">
                    <input
                      onChange={() =>
                        handleChange("is_free", !stepperFormdata.is_free)
                      }
                      checked={stepperFormdata.is_free}
                      type="checkbox"
                      id="free"
                      name="price"
                      className="form-check-input mt-0 me-2"
                    />
                    <label htmlFor="free">Free</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <p className="fs-6">Choose one of our categories</p>
              </div>
              <div className="col-md-6">
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="category-select-label">Categories</InputLabel>
                  <Select
                    labelId="category-select-label"
                    id="category-select"
                    label="Categories"
                    onChange={(e) => {
                      handleChange("category", e.target.value);
                      const selectedCategory = categories.find(
                        (cat) => String(cat.id) === String(e.target.value)
                      );
                      setsubCategory(selectedCategory?.subcategories || []);
                      handleChange("subcategory", "");
                      handleChange("subsubcategory", "");
                    }}
                    value={categorySelectValue}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {categories?.length ? (
                      categories.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        No items available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>

                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="subcategory-select-label" className="fs-6">
                    Subcategories
                  </InputLabel>
                  <Select
                    labelId="subcategory-select-label"
                    id="subcategory-select"
                    label="Sub Categories"
                    value={subcategorySelectValue}
                    onChange={(e) => {
                      handleChange("subcategory", e.target.value);
                      filterSubSubCategories(e.target.value);
                      handleChange("subsubcategory", "");
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {subcategory?.length ? (
                      subcategory.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        No items available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>

                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="subsubcategory-select-label" className="fs-6">
                  Sub-Subcategories
                  </InputLabel>
                  <Select
                    labelId="subsubcategory-select-label"
                    id="subsubcategory-select"
                    label="Sub Sub Categories"
                    value={subsubcategorySelectValue}
                    onChange={(e) => {
                      handleChange("subsubcategory", e.target.value);
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {filteredSubSubcategories?.length ? (
                      filteredSubSubcategories.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        No items available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>

                <p className="text-danger text-start">
                  {fieldErrors?.subsubcategory}
                </p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <p className="fs-6">
                  If You're using product Form specific print provider you can
                  set it here. If it's a Common product, just pick one that
                  sells it.
                </p>
              </div>
              <div className="col-md-6">
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="print-provider-select-label" className="fs-6">
                    Print Provider
                  </InputLabel>
                  <Select
                    labelId="print-provider-select-label"
                    id="print-provider-select"
                    label="Print Provider"
                    value={stepperFormdata?.linked_print_provider || ""}
                    onChange={(e) => {
                      handleChange("linked_print_provider", e.target.value);
                      getFilteredProducts(e.target.value);
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {printingPoducts?.length ? (
                      printingPoducts.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        No items available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
                <p className="text-danger text-start">
                  {fieldErrors?.linked_print_provider}
                </p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <p className="fs-6">
                  Use the product name from print provider website. Like "15oz
                  mug" or "Bella Canvas 3001"
                </p>
              </div>
              <div className="col-md-6">
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="product-select-label" className="fs-6">
                    Product Name
                  </InputLabel>
                  <Select
                    labelId="product-select-label"
                    id="product-select"
                    label="Product Name"
                    value={stepperFormdata?.linked_product ?? ""}
                    onChange={(e) =>
                      handleChange("linked_product", e.target.value)
                    }
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {productsLoading ? (
                      <MenuItem
                        disabled
                        value=""
                        sx={{ justifyContent: "center" }}
                      >
                        <CircularProgress size={24} />
                      </MenuItem>
                    ) : Array.isArray(products) &&
                      products.filter(Boolean).length > 0 ? (
                      products.map((item) =>
                        item ? (
                          <MenuItem
                            key={item.id ?? item._id}
                            value={item.id ?? item._id}
                          >
                            {item.product_name}
                          </MenuItem>
                        ) : null
                      )
                    ) : (
                      <MenuItem disabled value="">
                        No items available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
                <p className="text-danger text-start">
                  {fieldErrors?.linked_product}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

